import styled from 'styled-components';
import React from 'react';

export interface StyledTwoColumnHeadlineProps {
  readonly children: React.ReactNode;
}

const StyledTwoColumnHeadline = styled.div`
  display: grid;
  grid-gap: ${(props) => props.theme.internal.size.static150};

  @media (min-width: ${(props) =>
      props.theme.brand.spacing.customOneColumnBreakpoint ||
      props.theme.internal.Breakpoints.b960}px) {
    grid-template-columns: 1fr 1fr;
    width: 100%;

    > :last-child:not(:first-child) {
      text-align: right;
    }
  }
`;

export function TwoColumnHeadline({
  children,
}: StyledTwoColumnHeadlineProps): JSX.Element {
  return <StyledTwoColumnHeadline>{children}</StyledTwoColumnHeadline>;
}
